import { render, staticRenderFns } from "./AdicionarMotivoInatividade.vue?vue&type=template&id=a57ff8a4"
import script from "./AdicionarMotivoInatividade.vue?vue&type=script&lang=ts"
export * from "./AdicionarMotivoInatividade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports